(function(){
  function moneyFromCents(cents){
    try { return (cents/100).toFixed(2); } catch(e){ return ''; }
  }

  function ensureModal(){
    if(document.querySelector('[data-go-ss-modal]')) return;

    const modal = document.createElement('div');
    modal.setAttribute('data-go-ss-modal','');
    modal.hidden = true;
    modal.innerHTML = `
      <div class="go-ssm__overlay" data-go-ss-close></div>
      <div class="go-ssm__card" role="dialog" aria-modal="true" aria-label="Choose delivery frequency">
        <button type="button" class="go-ssm__x" data-go-ss-close aria-label="Close">×</button>
        <div class="go-ssm__title">Delivery frequency</div>
        <label class="go-ssm__label">Select frequency</label>
        <select class="go-ssm__select" data-go-ss-select></select>
        <button type="button" class="go-ssm__cta" data-go-ss-confirm>Add subscription</button>
      </div>
    `;
    document.body.appendChild(modal);

    const style = document.createElement('style');
    style.textContent = `
      [data-go-ss-modal]{position:fixed;inset:0;z-index:999999;display:grid;place-items:center}
      [data-go-ss-modal][hidden]{display:none}
      .go-ssm__overlay{position:absolute;inset:0;background:rgba(0,0,0,.42)}
      .go-ssm__card{position:relative;width:min(520px,92vw);background:#fff;border-radius:24px;padding:18px}
      .go-ssm__x{position:absolute;right:14px;top:10px;border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer}
      .go-ssm__title{font-weight:950;font-size:18px;margin:2px 0 10px}
      .go-ssm__label{display:block;font-weight:900;font-size:12px;letter-spacing:.08em;text-transform:uppercase;margin:10px 0 8px}
      .go-ssm__select{width:100%;border:1px solid #e6e6e6;border-radius:14px;padding:12px;font-weight:800}
      .go-ssm__cta{margin-top:12px;width:100%;border:0;border-radius:999px;padding:14px 16px;font-weight:950;cursor:pointer;background:#2D2C56;color:#fff}
    `;
    document.head.appendChild(style);
  }

  ensureModal();

  const modal = document.querySelector('[data-go-ss-modal]');
  const select = modal.querySelector('[data-go-ss-select]');
  const confirm = modal.querySelector('[data-go-ss-confirm]');

  let activeData = null;
  let selectedPlanId = null;

  function openModal(data){
    activeData = data;
    const plans = data.plans || [];
    const allocs = data.allocations || [];
    const allocMap = new Map(allocs.map(a => [String(a.plan_id), a]));

    select.innerHTML = '';
    plans.forEach((p, idx) => {
      const a = allocMap.get(String(p.plan_id));
      const opt = document.createElement('option');
      opt.value = p.plan_id;
      opt.textContent = (a && typeof a.price === 'number')
        ? `${p.name} — $${moneyFromCents(a.price)}`
        : p.name;
      if(idx === 0) selectedPlanId = String(p.plan_id);
      select.appendChild(opt);
    });

    select.onchange = () => selectedPlanId = String(select.value);
    modal.hidden = false;
  }

  function closeModal(){
    modal.hidden = true;
    activeData = null;
    selectedPlanId = null;
  }

  async function addToCart(payload){
    await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(payload)
    });

    // Best-effort open cart drawer
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    const drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if(drawer){
      drawer.classList.add('is-open');
      drawer.setAttribute('open','');
      return;
    }
    window.location.href = '/cart';
  }

  // Close modal clicks
  document.addEventListener('click', (e) => {
    if(e.target.closest('[data-go-ss-close]')) closeModal();
  });
  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  // Confirm subscription
  confirm.addEventListener('click', async () => {
    if(!activeData || !selectedPlanId) return;
    try{
      await addToCart({ id: activeData.variant_id, quantity: 1, selling_plan: selectedPlanId });
      closeModal();
    }catch(err){
      console.warn(err);
      window.location.href = '/cart';
    }
  });

  // MAIN: event delegation so it works after facets AJAX swaps the grid
  document.addEventListener('click', async (e) => {
    const onceBtn = e.target.closest('[data-go-ss-once]');
    const subBtn  = e.target.closest('[data-go-ss-sub]');
    if(!onceBtn && !subBtn) return;

    const card = e.target.closest('[data-go-ss-card]');
    if(!card) return;

    const jsonEl = card.querySelector('[data-go-ss-json]');
    if(!jsonEl) return;

    let data;
    try{ data = JSON.parse(jsonEl.textContent || '{}'); }catch(_){ return; }

    if(onceBtn){
      try{
        await addToCart({ id: data.variant_id, quantity: 1 });
      }catch(err){
        console.warn(err);
        window.location.href = '/cart';
      }
      return;
    }

    if(subBtn){
      if(subBtn.disabled) return;
      openModal(data);
    }
  });
})();